"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function fromBase64URL() {
  var base64URLString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return base64URLString.replace(/%2B/g, "+").replace(/%2F/g, "/").replace(/%3D/g, "=");
}

exports.default = fromBase64URL;